import { useMutation } from '@apollo/client';
import { usePropertyContext } from 'context/propertyContext';
import { useUser } from 'features/users/context/userContext';
import { MAKE_STAY_DATE_FAV_OR_NOT } from 'queries/gqlRecReview';

export const useFavStayDate = (stayDate?: string) => {
	const { property } = usePropertyContext();
	const { user } = useUser();
	const propertyId = property?.propertyId;
	const userId = user?.id;

	return useMutation<any, Record<string, any>>(MAKE_STAY_DATE_FAV_OR_NOT, {
		variables: { propertyId, userId, stayDate },
	});
};
